import styled from "styled-components";

interface Props {
	data: { label: string; text: string | string[]; link?: string }[];
}

export const SummaryTable: React.FC<Props> = ({ data }) => {
	return (
		<Styles>
			<tbody>
				{data.map((row, i) => (
					<tr key={row.label + i}>
						<th>{row.label}</th>
						<td>{Array.isArray(row.text) ? row.text.join("\n") : row.text}</td>
					</tr>
				))}
			</tbody>
		</Styles>
	);
};

const Styles = styled.table`
	width: 100%;
	font-size: 0.9rem;

	th {
		font-weight: 500;
		width: 30%;
		vertical-align: top;
	}

	th,
	td {
		background: #f9f9f9;
		padding: 0.75rem;
		line-height: 1.7;
	}

	th {
		text-align: right;
	}

	td {
		white-space: pre-line;
	}
`;
